<div class="flex items-center flex-none w-full">
    <fa-icon
        class="px-2 py-4 text-custom-blue"
        size="lg"
        [icon]="['fas', 'triangle-exclamation']" />

    <span class="font-normal text-xs text-custom-dark-grey">{{ displayedMessage() | transloco }}</span>
</div>
